<section fxFlex="100" fxLayout="column" class="catalog-products-list">
  <div class="catalog-products-list__catalog" fxLayout="column">
    <div
      [fxFlex]="isSearchPage && (isZeroResult) ? 100 : 80"
      fxFlex.mm-tablet="100"
      fxFlex.mm-mobile="100"
      fxLayout="column"
    >
      <div>
        <ng-container *ngIf="!isDesktop; else desktopLayout">
          <ng-container *ngTemplateOutlet="mainToolbarAndActions"></ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="isCustomPLPPage && (seoContent?.active && seoContent?.introContent)">
        <div class="catalog-products-list__catalog__seo-content">
          <app-rich-content [content]="seoContent.introContent"></app-rich-content>
        </div>
      </ng-container>

      <ng-container *ngIf="!isMobileOrTablet">
        <ng-container *ngTemplateOutlet="categoryChildren"></ng-container>
      </ng-container>

      <ng-container *ngIf="seoContent; else SBTContent">
        <app-image-header
          *ngIf="seoContent?.active && seoContent?.banners" [promoImage]="seoContent.banners"
        ></app-image-header>
      </ng-container>

      <ng-template #SBTContent>
        <!-- Storyblok dynamic top content -->
        <div *ngIf="storyblokTopContent?.length">
          <div *ngFor="let blok of storyblokTopContent" [appStoryblokEditable]="blok._editable">
            <ndc-dynamic [ndcDynamicComponent]="components[blok.component]" [ndcDynamicInputs]="blok"></ndc-dynamic>
          </div>
        </div>
      </ng-template>
      <app-category-facets-carousel *ngIf="showCategoryFacets"></app-category-facets-carousel>
      <app-filter-facets-carousel
        *ngIf="showFilterFacets && (!isDesktop || (isDesktop && hasFilters))"
        [isMobileOrTablet]="isMobileOrTablet"
        [queryParams]="queryParams"
        [isMobile]="isMobile"
        [isTablet]="isTablet"
        [isDesktop]="isDesktop"
        (togglePriceFilter)="togglePriceFilter()"
        (toggleCategoryFilter)="toggleCategoryFilter()"
        (toggleAttributeFilter)="toggleAttributeFilter($event)"
      ></app-filter-facets-carousel>
    </div>

    <div fxLayout="row" [ngClass]="{'gutter16': (isNewPLPVariantRestyle$ | async) && isPLP && !isMobileOrTablet}">
      <div
        *ngIf="!(isSearchPage && (isZeroResult))"
        fxLayout="row"
        fxLayoutAlign="space-between"
        fxFlex="20"
        fxFlex.mm-tablet="0"
        fxFlex.mm-mobile="0"
        class="catalog-products-list__list"
      >
        <aside
          class="catalog-products-list__catalog__filters height-80"
          [ngClass]="{
            'catalog-products-list__catalog__filters--opened': isFiltersBarOpened$ | async,
            'margin-right': !(isNewPLPVariantRestyle$ | async) && isPLP
          }"
        >
          <app-search-filters
            [queryParams]="queryParams"
            [productsCount]="totalCount"
            [categories]="selectedCategory?.children"
            [isFilterOpen]="isFiltersBarOpened$ | async"
            [isZeroResult]="isZeroResult"
            [isCategoryListFilter]="isCategoryListFilter$ | async"
            [isCategoryPage]="isCategoryPage"
            [isCustomPLPPage]="isCustomPLPPage"
            [isSearchPage]="isSearchPage"
            [isDesktop]="isDesktop"
            [isMobile]="isMobile"
            [isMobileOrTablet]="isMobileOrTablet"
            [isTablet]="isTablet"
            (filtersClosed)="toggleFilters(false, $event)"
          ></app-search-filters>
        </aside>
        <app-search-filters
          *ngIf="!isDesktop && ((specificFilterType && specificFilterType?.type))"
          [@inOutAnimation]
          class="catalog-products-list__catalog__filters"
          [ngClass]="{
            'specific-filter': !!specificFilterType && specificFilterType?.type
          }"
          [queryParams]="queryParams"
          [productsCount]="totalCount"
          [categories]="selectedCategory?.children"
          [isFilterOpen]="isFiltersBarOpened$ | async"
          [isZeroResult]="isZeroResult"
          [isCategoryListFilter]="isCategoryListFilter$ | async"
          [isCategoryPage]="isCategoryPage"
          [isCustomPLPPage]="isCustomPLPPage"
          [isSearchPage]="isSearchPage"
          [isDesktop]="!isMobileOrTablet"
          [isMobile]="isMobile"
          [isMobileOrTablet]="isMobileOrTablet"
          [filterType]="specificFilterType"
          (filtersClosed)="toggleFilters(false, $event)"
          (specificFilterClosed)="toggleSpecificFilters($event)"
        ></app-search-filters>
      </div>
      <div fxLayout="column" fxFlex="100">
        <div
          [fxFlex]="100"
          fxFlex.mm-tablet="100"
          fxFlex.mm-mobile="100"
          fxLayout="column"
        >
          <div
            #stickyParent
            [ngClass]="{ 'sticky-actions': isStickyActions }"
            class="catalog-products-list__catalog__body"
            fxFlex="100"
            fxFlex.mm-lt-tablet-landscape="100"
          >
            <ng-container *ngIf="(!isZeroResult || (isExpired || hasFilters)); else zeroResults">
              <app-catalog-body
                [searchQuery]="searchQuery"
                [products]="products"
                [queryParams]="queryParams"
                [totalCount]="totalCount"
                [isCustomPLPPage]="isCustomPLPPage"
                [recommendedProducts]="recommendedProducts"
                [recommendedProductsType]="recommendedProductsType"
                [isZeroResult]="isZeroResult"
                [isMobileOrTablet]="isMobileOrTablet"
                [isDesktop]="isDesktop"
                [searchCorrection]="searchCorrection"
                [hasFilters]="hasFilters"
                [isExpired]="isExpired"
                [isTablet]="isTablet"
                [isCategoryPage]="isCategoryPage"
                [selectedCategory]="selectedCategory"
                [isMobile]="isMobile">
              </app-catalog-body>
            </ng-container>

            <ng-template #zeroResults>
              <app-search-zero-result-search
                [isMobile]="isMobile"
                [isDesktop]="isDesktop"
                [searchTerm]="searchQuery"
                [recommendedProductsFromSearchResponse]="recommendedProducts"
                [recommendedProductsType]="recommendedProductsType"
                [hasFilters]="hasFilters"
                [isExpired]="isExpired"
                [isCategoryPage]="isCategoryPage"
              ></app-search-zero-result-search>
            </ng-template>
          </div>
        </div>
        <section
          [ngClass]="{
            'catalog-products-list__seo--empty': (!seoContent || !seoContent.active) && !storyblokBottomContent?.length,
            'catalog-products-list__seo': seoContent || storyblokBottomContent?.length,
            'padding0': (isNewPLPVariantRestyle$ | async) && isPLP
          }"
        >
          <ng-container *ngIf="((seoContent && seoContent.active) || storyblokBottomContent?.length) && !isFirstPage">
            <app-page-content-wrapper [contentWidth]="'95vw'" [contentPadding]="'0px'">
              <app-newsletter-wrapper [hasSeoContent]="!!seoContent" [source]="customPLPNewsletterSource" [isSmallSize]="true"></app-newsletter-wrapper>
            </app-page-content-wrapper>
          </ng-container>

          <ng-container *ngIf="seoContent; else SBBottomContent">
            <app-custom-seo-content *ngIf="isFirstPage" [seoContent]="seoContent" [source]="customPLPNewsletterSource">
            </app-custom-seo-content>
          </ng-container>

          <ng-template #SBBottomContent>
            <!-- Storyblok dynamic bottom content -->
            <div
              *ngIf="isFirstPage && storyblokBottomContent?.length"
              class="catalog-products-list__seo__storyblok-content"
              [appStoryblokEditable]="mainEditable"
            >
              <div *ngFor="let blok of storyblokBottomContent" [appStoryblokEditable]="blok._editable">
                <ndc-dynamic [ndcDynamicComponent]="components[blok.component]" [ndcDynamicInputs]="blok"></ndc-dynamic>
              </div>
            </div>
          </ng-template>
        </section>
      </div>
    </div>
  </div>

  <div
    *ngIf="(isFiltersBarOpened$ | async) || !!specificFilterType"
    class="catalog-products-list__overlay"
    (click)="toggleFilters(false, applicationEventFilterAreaInteractionType.Close)"
  ></div>
</section>

<ng-template #desktopLayout>
  <div class="catalog-products-list__toolbar-storyblok-wrapper">
    <ng-container *ngTemplateOutlet="mainToolbarAndActions"></ng-container>
  </div>
</ng-template>

<ng-template #mainToolbarAndActions>
  <div class="catalog-products-list__catalog__toolbar">
    <app-search-catalog-toolbar
      *ngIf="!(isZeroResult) || ((isExpired) || (hasFilters))"
      [searchTerm]="searchQuery"
      [searchCorrection]="searchCorrection"
      [totalCount]="totalCount"
      [queryParams]="queryParams"
      [customTitle]="(customPlpConfigContent$ | async)?.title"
      [selectedCategory]="selectedCategory"
    ></app-search-catalog-toolbar>
  </div>

  <ng-container *ngIf="isMobileOrTablet">
    <ng-container *ngTemplateOutlet="categoryChildren"></ng-container>
  </ng-container>

  <!--  For mobile, sticky-->
  <div
    *ngIf="isMobileOrTablet && !(isZeroResult)"
    class="catalog-products-list__catalog__actions"
    fxLayoutAlign="end start"
    appSticky
    [ngClass]="{'is-sticky': isStickyActions,
    'whiteBg': !(isNewPLPVariantRestyle$ | async) && isPLP}"
    [offset]="0"
    [stickTo]="stickyParent"
    [needToRecalculate]="layoutChanged"
    (stickyStatusChanged)="onActionsStickyStatusChange($event)"
  >
    <app-search-catalog-actions
      fxFlex="100"
      [queryParams]="queryParams"
      [isSticky]="isStickyActions"
      [isDesktop]="isDesktop"
      [isCategoryPage]="isCategoryPage"
      (filterOpened)="toggleFilters(true, applicationEventFilterAreaInteractionType.Open)">
    </app-search-catalog-actions>
  </div>
  <!--  For desktop, not sticky-->
  <div
    *ngIf="!isMobileOrTablet && !(isZeroResult)"
    class="catalog-products-list__catalog__actions"
    fxLayoutAlign="end start"
  >
    <app-search-catalog-actions
      fxFlex="100"
      [queryParams]="queryParams"
      [isSticky]="isStickyActions"
      [isDesktop]="isDesktop"
      [isCategoryPage]="isCategoryPage"
      (filterOpened)="toggleFilters(true, applicationEventFilterAreaInteractionType.Open)">
    </app-search-catalog-actions>
  </div>
</ng-template>

<ng-template #categoryChildren>
  <div
    *ngIf="isCategoryPage && !(isCategoryListFilter$ | async) && selectedCategory?.children?.length"
    class="toolbar-search__category-children"
  >
    <app-search-category-children
      [categories]="selectedCategory.children"
      [isMobileOrTablet]="isMobileOrTablet"
      (showAllClick)="onShowAllCategoryChildren()"
    ></app-search-category-children>
  </div>
</ng-template>
